import type { TranslationMessages } from '../../types';

export const shift_planning: TranslationMessages = {
  loading: 'Đang tải kế hoạch ca làm việc...',
  create_success: 'Ca làm việc đã được tạo thành công!',
  create_error: 'Không thể tạo ca làm việc',
  update_success: 'Ca làm việc đã được cập nhật thành công!',
  update_error: 'Không thể cập nhật ca làm việc',
  delete_success: 'Ca làm việc đã được xóa thành công!',
  delete_error: 'Không thể xóa ca làm việc',
  scheduled_shifts_title: 'Các ca làm việc đã lên lịch',
  scheduled_shifts_description:
    'Quản lý và giám sát tất cả các ca làm việc của nhân viên',
  table_staff: 'Thành viên nhân viên',
  table_datetime: 'Ngày & Giờ',
  table_position: 'Vị trí',
  table_location: 'Địa điểm',
  table_status: 'Trạng thái',
  table_actions: 'Hành động',
  create_title: 'Tạo ca làm việc mới',
  create_description:
    'Lên lịch một ca làm việc mới cho một thành viên nhân viên',
  edit_title: 'Chỉnh sửa ca làm việc',
  edit_description: 'Cập nhật chi tiết ca làm việc',
  staff_label: 'Thành viên nhân viên *',
  staff_placeholder: 'Chọn thành viên nhân viên',
  date_label: 'Ngày *',
  start_time_label: 'Thời gian bắt đầu *',
  end_time_label: 'Thời gian kết thúc *',
  position_label: 'Vị trí (Tùy chọn)',
  position_placeholder: 'Chọn vị trí',
  location_label: 'Địa điểm (Tùy chọn)',
  location_placeholder: 'Nhập địa điểm',
  notes_label: 'Ghi chú',
  notes_placeholder: 'Ghi chú bổ sung cho ca làm việc này...',
  recurring_label: 'Đặt đây là ca làm việc định kỳ',
  recurring_pattern_label: 'Mẫu định kỳ',
  recurring_pattern_placeholder: 'Chọn mẫu',
  recurring_weekly: 'Hàng tuần',
  recurring_biweekly: 'Hai tuần một lần',
  recurring_monthly: 'Hàng tháng',
  create_button: 'Tạo ca làm việc',
  update_button: 'Cập nhật ca làm việc',
  delete_button: 'Xóa',
  delete_confirm: 'Bạn có chắc chắn muốn xóa ca làm việc này không?',
};
